import React from 'react';

// Microsoft Logo SVG Component (4-square logo)
const MicrosoftLogo = ({ size = "18" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#F25022" d="M1 1h10v10H1z"/>
    <path fill="#00A4EF" d="M13 1h10v10H13z"/>
    <path fill="#7FBA00" d="M1 13h10v10H1z"/>
    <path fill="#FFB900" d="M13 13h10v10H13z"/>
  </svg>
);

/**
 * Microsoft Sign In Button Molecule
 * A specialized button for Microsoft authentication following Microsoft's brand guidelines
 */
const MicrosoftSignInButton = ({ 
  loading = false,
  onClick,
  disabled = false,
  text = "Sign in with Microsoft",
  className = ""
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`btn d-flex align-items-center justify-content-center ${className}`}
      style={{
        minHeight: '48px',
        backgroundColor: '#2F2F2F',
        border: '1px solid #2F2F2F',
        borderRadius: '2px',
        color: '#ffffff',
        fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, sans-serif',
        fontSize: '14px',
        fontWeight: '600',
        padding: '0 24px',
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        opacity: disabled ? 0.6 : 1
      }}
      onMouseEnter={(e) => {
        if (!disabled && !loading) {
          e.target.style.backgroundColor = '#106ebe';
          e.target.style.borderColor = '#106ebe';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && !loading) {
          e.target.style.backgroundColor = '#2F2F2F';
          e.target.style.borderColor = '#2F2F2F';
        }
      }}
      onMouseDown={(e) => {
        if (!disabled && !loading) {
          e.target.style.backgroundColor = '#005a9e';
          e.target.style.borderColor = '#005a9e';
        }
      }}
      onMouseUp={(e) => {
        if (!disabled && !loading) {
          e.target.style.backgroundColor = '#106ebe';
          e.target.style.borderColor = '#106ebe';
        }
      }}
    >
      {loading ? (
        <div className="spinner-border spinner-border-sm me-2" role="status" style={{color: '#ffffff'}}>
          <span className="visually-hidden">Loading...</span>
        </div>
      ) : (
        <MicrosoftLogo size="18" />
      )}
      <span className="ms-2">{text}</span>
    </button>
  );
};

export default MicrosoftSignInButton;
